// We need the following rate type guards because TypeScript can't narrow `rate` based on a
// narrowing of `rate.service`. If we wanted to this inline, we'd have to construct a new object,
// like so.
//
// ```typescript
// if (rate.service.type === 'lpc') {
//   const thisFails: App.EnrichedLpcPropertyRate = rate
//   const thisWorks: App.EnrichedLpcPropertyRate = { ...rate, service: rate.service }
// }
// ```
//
// For further details, see <https://github.com/microsoft/TypeScript/issues/42384>.

export function isLpcRate(rate: App.EnrichedPropertyRate): rate is App.EnrichedLpcPropertyRate {
  return rate.service.type === 'lpc'
}

export function isBedbankRate(rate: App.EnrichedPropertyRate): rate is App.EnrichedBedbankPropertyRate {
  return rate.service.type === 'bedbank'
}
